export const toggleContent = (toggleTriggerElement) => {
  toggleTriggerElement.addEventListener("click", (e) => {

    const shownClass = "js-toggle-show"
    const hiddenClass = "js-toggle-hiden"

    e.preventDefault();
    const targetValue = toggleTriggerElement.dataset.toggleTarget
    const targets = document.querySelectorAll('[data-toggle-content="' + targetValue + '"]')

    if (!targets || targets == null) return;

    targets.forEach(target => {
      if (target.offsetParent === null || target.classList.contains(hiddenClass)) {
        target.classList.remove(hiddenClass)
        target.classList.add(shownClass)
        return;
      }

      if (target.offsetParent !== null || target.classList.contains(shownClass)) {
        target.classList.remove(shownClass)
        target.classList.add(hiddenClass)
        return;
      }
    })

  })
}

/**
 * Function for toggle content
 * Element params:
 * [data-toggle-target] - required, id of target element, e.g. data-target="chinese-horoscope-section"
 *
 * Target params:
 * [data-toggle-content] - required, id of target element, e.g. data-target="chinese-horoscope-section"
 * [data-toggle-style] - optional css display property of displaied element "flex / block (default) / inline" e.g. data-toggle-style="flex"
 * 👆 could be extended in scss/utilities/u-toggle.scss
 */

const toggleTriggers = document.querySelectorAll("[data-toggle-target]");
toggleTriggers.forEach(toggleContent);

